import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { InfoTip } from "@/components/InfoTip";
import { statusLabel } from "@/lib/pipeline";
import { History } from "lucide-react";

const TXT = {
  position_added: (m) => `Zaradený na pozíciu ${m.position} (${m.area})`,
  position_removed: (m) => `Odobratá pozícia ${m.position}`,
  position_status_change: (m) => `${m.position}: ${statusLabel(m.from)} → ${statusLabel(m.to)}`,
};
const line = (h) => (TXT[h.action] ? TXT[h.action](h.meta || {}) : `${statusLabel(h.meta?.from)} → ${statusLabel(h.meta?.to || h.action.replace("pipeline_", ""))}`);

export function StatusHistory({ profileId, refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/company/candidate/${profileId}/status-history`).then((r) => setItems(r.data.history || [])).catch(() => setItems([]));
  }, [profileId, refreshKey]);
  return (
    <div className="rounded-3xl bg-white border border-slate-200 shadow-sm p-5" data-testid="status-history">
      <h3 className="font-head font-semibold flex items-center gap-2 text-[#1e2a5a]"><History size={17} className="text-violet-600" /> História zmien stavu
        <InfoTip text="Každá zmena stavu kandidáta alebo jeho pozície sa zaznamená s dátumom a recruiterom." /></h3>
      {items && items.length === 0 && <p className="mt-3 text-xs text-slate-400" data-testid="status-history-empty">Zatiaľ bez zmien.</p>}
      <ol className="mt-3 space-y-2.5 max-h-64 overflow-y-auto">
        {(items || []).map((h) => (
          <li key={h.id} className="border-l-2 border-violet-200 pl-3" data-testid={`history-${h.id}`}>
            <div className="text-xs font-semibold text-slate-700">{line(h)}</div>
            <div className="text-[11px] text-slate-400">{new Date(h.created_at).toLocaleString("sk-SK")}{h.by_name ? ` · ${h.by_name}` : ""}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}
